interface ContentSegment {
  text: string;
  isBold?: boolean;
}

interface ContentItem {
  type: "paragraph" | "list";
  segments: ContentSegment[];
  items?: string[];
}

interface BlogEventDescriptionProps {
  content: ContentItem[];
}

export const BlogEventDescription = ({
  content,
}: BlogEventDescriptionProps) => {
  return (
    <section className="flex flex-col gap-4 bg-secondary px-4 pb-14 text-primary ph:px-24 md:px-48 lg:px-72 xl:px-96">
      {content.map((contentItem, index) => (
        <div key={index}>
          {contentItem.type === "paragraph" && (
            <div>
              {contentItem.segments.map((segment, segIndex) => (
                <span
                  key={segIndex}
                  className={segment.isBold ? "font-semibold" : ""}
                >
                  {segment.text}
                </span>
              ))}
            </div>
          )}
          {contentItem.type === "list" && (
            <div>
              {contentItem.segments.map((segment, segIndex) => (
                <span
                  key={segIndex}
                  className={segment.isBold ? "font-semibold" : ""}
                >
                  {segment.text}
                </span>
              ))}
              <ul className="list-disc pl-6">
                {contentItem.items?.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </section>
  );
};
